import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const DailyFlowsForm = () => {
  const [formData, setFormData] = useState({
    date: new Date(),
    texana: '',
    colorado: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [noDataAlert, setNoDataAlert] = useState(null);

  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };

  const formatDisplayDate = (date) => {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const fetchData = async (date) => {
    setLoading(true);
    setNoDataAlert(null);
    setError(null);
    setSuccess(false);
    
    try {
      const response = await fetch(`https://cctexasfinance.com:9090/passthrough/daily_flows?date=${formatDate(date)}`);
      
      if (response.status === 404) {
        setNoDataAlert(`No data available for ${formatDisplayDate(date)}`);
        setFormData(prev => ({
          ...prev,
          date: date,
          texana: '',
          colorado: ''
        }));
        return;
      }
      
      if (response.status !== 200) throw new Error('Failed to fetch data');
      
      const data = await response.json();
      
      setFormData(prev => ({
        ...prev,
        date: date,
        texana: data.texana !== undefined ? data.texana.toString() : '',
        colorado: data.colorado !== undefined ? data.colorado.toString() : ''
      }));
      
    } catch (err) {
      console.error('Error fetching data:', err);
      //setError('Failed to load data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(formData.date);
  }, []);

  const handleDateChange = (date) => {
    setFormData(prev => ({ ...prev, date }));
    fetchData(date);
  };

  const navigateDate = (direction) => {
    const newDate = new Date(formData.date);
    newDate.setDate(newDate.getDate() + direction);
    handleDateChange(newDate);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    
    try {
      const response = await fetch('http://10.9.4.46:9989/api/daily_flows', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          date: formatDate(formData.date),
          texana: parseFloat(formData.texana) || 0,
          colorado: parseFloat(formData.colorado) || 0
        }),
      });
      
      if (response.status !== 200) throw new Error('Failed to submit data');
      
      setSuccess(true);
      setTimeout(() => setSuccess(false), 5000);
      fetchData(formData.date);
      
    } catch (err) {
      console.error('Error submitting data:', err);
      //setError('Failed to save data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="daily-flows-container">
      <div className="daily-flows-card">
        <div className="card-header">
          <svg className="google-icon" viewBox="0 0 24 24">
            <path d="M6,8a2,2 0 1,0 4,0a2,2 0 1,0 -4,0" fill="#4285F4"></path>
            <path d="M14,8a2,2 0 1,0 4,0a2,2 0 1,0 -4,0" fill="#EA4335"></path>
            <path d="M6,16a2,2 0 1,0 4,0a2,2 0 1,0 -4,0" fill="#FBBC05"></path>
            <path d="M14,16a2,2 0 1,0 4,0a2,2 0 1,0 -4,0" fill="#34A853"></path>
          </svg>
          <h1 className="form-title">Daily Flow Rates</h1>
        </div>
        
        <div className="form-content">

          <form onSubmit={handleSubmit}>
            <div className="date-control">
              <label className="form-label">Date</label>
              <div className="date-navigation">
                <button 
                  type="button" 
                  className="nav-button" 
                  onClick={() => navigateDate(-1)}
                >
                  <svg viewBox="0 0 24 24">
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                  </svg>
                </button>
                
                <DatePicker
                  selected={formData.date}
                  onChange={handleDateChange}
                  className="date-picker"
                  dateFormat="MMM d, yyyy"
                />
                
                <button 
                  type="button" 
                  className="nav-button"
                  onClick={() => navigateDate(1)}
                >
                  <svg viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                  </svg>
                </button>
              </div>
            </div>

            <div className="form-fields">
              <div className="form-field">
                <label className="form-label">Texana Flow Rate</label>
                <div className="input-wrapper">
                  <input
                    type="number"
                    className="text-input"
                    name="texana"
                    value={formData.texana}
                    onChange={handleInputChange}
                    step="0.001"
                    placeholder="0.000"
                  />
                  <span className="unit">cfs</span>
                </div>
              </div>
              
              <div className="form-field">
                <label className="form-label">Colorado Flow Rate</label>
                <div className="input-wrapper">
                  <input
                    type="number"
                    className="text-input"
                    name="colorado"
                    value={formData.colorado}
                    onChange={handleInputChange}
                    step="0.001"
                    placeholder="0.000"
                  />
                  <span className="unit">cfs</span>
                </div>
              </div>
            </div>
            
            <button 
              type="submit" 
              className="submit-button"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save'}
            </button>
          </form>

          {loading && (
            <div className="loading-overlay">
              <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
                <div className="bounce4"></div>
              </div>
            </div>
          )}
          
          <div className="alerts-container">
            {error && (
              <div className="alert error-alert">
                <svg viewBox="0 0 24 24" className="alert-icon">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
                </svg>
                <span>{error}</span>
                <button className="close-button" onClick={() => setError(null)}>×</button>
              </div>
            )}
            
            {noDataAlert && (
              <div className="alert warning-alert">
                <svg viewBox="0 0 24 24" className="alert-icon">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
                </svg>
                <span>{noDataAlert}</span>
                <button className="close-button" onClick={() => setNoDataAlert(null)}>×</button>
              </div>
            )}
            
            {success && (
              <div className="alert success-alert">
                <svg viewBox="0 0 24 24" className="alert-icon">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
                </svg>
                <span>Data saved successfully!</span>
              </div>
            )}
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .daily-flows-container {
          font-family: 'Google Sans', 'Roboto', Arial, sans-serif;
          display: flex;
          justify-content: center;
          padding: 20px;
        }
        
        .daily-flows-card {
          background: white;
          border-radius: 8px;
          box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 2px 6px 2px rgba(60, 64, 67, 0.15);
          width: 100%;
          max-width: 600px;
          overflow: hidden;
        }
        
        .card-header {
          display: flex;
          align-items: center;
          padding: 16px 24px;
          border-bottom: 1px solid #e0e0e0;
        }
        
        .google-icon {
          height: 24px;
          width: 24px;
          margin-right: 12px;
        }
        
        .form-title {
          color: #202124;
          font-size: 20px;
          font-weight: 500;
          margin: 0;
        }
        
        .form-content {
          padding: 24px;
          position: relative;
        }
        
        .alerts-container {
          position: fixed;
          bottom: 24px;
          left: 50%;
          transform: translateX(-50%);
          width: auto;
          max-width: 90%;
          z-index: 1100;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        
        .alert {
          display: flex;
          align-items: center;
          border-radius: 8px;
          padding: 10px 16px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          animation: slideUp 0.3s ease-out forwards;
          min-width: 280px;
        }
        
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .error-alert {
          background-color: #fce8e6;
          color: #d93025;
          border-left: 4px solid #d93025;
        }
        
        .warning-alert {
          background-color: #fef7e0;
          color: #e37400;
          border-left: 4px solid #e37400;
        }
        
        .success-alert {
          background-color: #e6f4ea;
          color: #137333;
          border-left: 4px solid #137333;
        }
        
        .alert-icon {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          fill: currentColor;
        }
        
        .close-button {
          background: none;
          border: none;
          color: inherit;
          cursor: pointer;
          font-size: 18px;
          margin-left: auto;
          padding: 0;
        }
        
        .date-control {
          margin-bottom: 24px;
        }
        
        .form-label {
          color: #5f6368;
          display: block;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 8px;
        }
        
        .date-navigation {
          display: flex;
          align-items: center;
          border: 1px solid #dadce0;
          border-radius: 4px;
          overflow: hidden;
        }
        
        .nav-button {
          background: none;
          border: none;
          color: #5f6368;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 36px;
          width: 36px;
          padding: 0;
        }
        
        .nav-button svg {
          width: 24px;
          height: 24px;
          fill: currentColor;
        }
        
        .nav-button:hover {
          background-color: #f1f3f4;
        }
        
        .date-picker {
          border: none;
          color: #202124;
          font-size: 14px;
          height: 36px;
          padding: 0 8px;
          text-align: center;
          width: 120px;
        }
        
        .date-picker:focus {
          outline: none;
        }
        
        .form-fields {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
          margin-bottom: 24px;
        }
        
        @media (min-width: 600px) {
          .form-fields {
            grid-template-columns: 1fr 1fr;
          }
        }
        
        .form-field {
          margin-bottom: 8px;
        }
        
        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }
        
        .text-input {
          background-color: #f1f3f4;
          border: 1px solid transparent;
          border-radius: 4px;
          color: #202124;
          font-size: 14px;
          height: 40px;
          padding: 0 12px;
          width: 100%;
          transition: background-color 0.2s, border-color 0.2s;
        }
        
        .text-input:focus {
          background-color: white;
          border-color: #1a73e8;
          outline: none;
        }
        
        .unit {
          color: #5f6368;
          font-size: 14px;
          position: absolute;
          right: 12px;
        }
        
        .submit-button {
          background-color: #1a73e8;
          border: none;
          border-radius: 4px;
          color: white;
          cursor: pointer;
          font-family: 'Google Sans', 'Roboto', sans-serif;
          font-size: 14px;
          font-weight: 500;
          height: 36px;
          min-width: 120px;
          padding: 0 24px;
          transition: background-color 0.2s;
        }
        
        .submit-button:hover {
          background-color: #1765cc;
        }
        
        .submit-button:disabled {
          background-color: #dadce0;
          color: #5f6368;
          cursor: not-allowed;
        }
        
        .loading-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(255, 255, 255, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
        }
        
        .spinner {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
        }
        
        .spinner > div {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          animation: bounce 1.4s infinite ease-in-out both;
        }
        
        .bounce1 {
          background-color: #4285F4;
          animation-delay: -0.32s !important;
        }
        
        .bounce2 {
          background-color: #EA4335;
          animation-delay: -0.16s !important;
        }
        
        .bounce3 {
          background-color: #FBBC05;
        }
        
        .bounce4 {
          background-color: #34A853;
          animation-delay: 0.16s !important;
        }
        
        @keyframes bounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1.0); }
        }
      `}</style>
    </div>
  );
};

export default DailyFlowsForm;